import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";

const ServicesSection = () => {
  return (
    <Box
      component="section"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      marginTop={{ xs: 4, md: 1.25 }}
      marginBottom={{ xs: 6, md: 6.25 }}
      width={"100%"}
      px={{ xs: 2.5, sm: 4, md: 12.5 }} // responsive padding
      bgcolor="background.default"
      gap={{ xs: 4, md: 6 }}
    >
      <Box
        component="img"
        src={"/websiteAssets/AboutUsWhatWeDo.png"}
        alt="Element"
        sx={{
          width: { xs: "100%", sm: "80%", md: "45%" },
          maxWidth: { xs: 520, md: 615 },
          height: "auto",
          maxHeight: { xs: 340, md: 420 },
          objectFit: "cover",
          borderRadius: { xs: "18px", md: "24px" },
          mx: "auto",
        }}
      />

      <Stack
        spacing={{ xs: 2.5, md: 3.125 }}
        width={{ xs: "100%", md: "45%" }}
        maxWidth={{ xs: "640px", md: "550px" }}
        textAlign={{ xs: "center", md: "left" }}
        mx="auto"
      >
        <Typography
          variant="h2"
          color="primary.main"
          sx={{
            fontFamily: "Jost-Bold, Montserrat",
            fontWeight: 700,
            fontSize: { xs: 36, sm: 42, md: 64 },
            letterSpacing: { xs: "-2px", md: "-3.84px" },
            lineHeight: { xs: 1.15, md: "normal" },
            whiteSpace: { xs: "normal", md: "nowrap" },
          }}
        >
          WHAT WE DO
        </Typography>

        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            fontFamily: "Poppins-Regular, Montserrat",
            fontSize: { xs: 14, sm: 15, md: 16 },
            width: "100%",
            lineHeight: 1.7,
          }}
        >
          Apna Card empowers teams and enterprises with a paperless solution for
          slead capture, employee management, medical records, and seamless
          collaboration, driving business growth and stronger connections.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          endIcon={<ArrowOutwardIcon />}
          sx={{
            width: { xs: "100%", sm: "fit-content" },
            minWidth: { xs: "100%", sm: 220 },
            height: { xs: 48, md: 55 },
            borderRadius: "10px",
            textTransform: "none",
            alignSelf: { xs: "center", md: "flex-start" },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Istok_Web-Bold, Montserrat",
              fontWeight: 700,
              fontSize: "16px",
              letterSpacing: "-0.64px",
            }}
          >
            Contact Us
          </Typography>
        </Button>
      </Stack>
    </Box>
  );
};

export default ServicesSection;
